export const Divisions = {
  Minerals: 2,
  Verifuel: 4,
  Food: 6,
  BVAQ: 8,
  MaxxLIMs: 9,
};
